import { useEffect } from "react";
import { Alert } from "react-bootstrap";
import { styleComponentAlert } from "./style";

/**
 * @param {Boolean} show Variable de control para mostrar el alert
 * @param {Boolean} setShow Variable de control para ocultar el alert
 * @param {String} title Titulo del alert
 * @param {String} content Contenido del alert
 * @param {String} variantAlert Tipo de alert (primary, secondary, success, danger, warning, info, light, dark)
 * @returns Custom Alert Bootstrap component
 */
const CustomAlert = ({ show, setShow, title, content, variantAlert }) => {
  useEffect(() => {
    setTimeout(() => {
      if (show) setShow(false);
    }, 4000);
  });

  return (
    <Alert
      show={show}
      variant={variantAlert}
      dismissible
      onClose={() => setShow(false)}
      style={styleComponentAlert.alertContainer}
    >
      <Alert.Heading>{title}</Alert.Heading>
      <p>{content}</p>
    </Alert>
  );
};

export default CustomAlert;
